<template>
    <or-layout>
        <a-form layout="inline">
            <a-form-item>
                <a-select v-model="form.subject" placeholder="学科" style="width: 120px;">
                    <a-select-option :value="1">数学</a-select-option>
                    <a-select-option :value="2">英语</a-select-option>
                    <a-select-option :value="3">语文</a-select-option>
                    <a-select-option :value="4">化学</a-select-option>
                    <a-select-option :value="5">物理</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-select v-model="form.type" mode="multiple" placeholder="班型" style="width: 120px;" allow-clear>
                    <a-select-option :key="0" :value="0">培优班</a-select-option>
                    <a-select-option :key="1" :value="1">提高班</a-select-option>
                    <a-select-option :key="2" :value="2">英才班</a-select-option>
                    <a-select-option :key="3" :value="3">1对1VIP班</a-select-option>
                    <a-select-option :key="4" :value="4">体验课</a-select-option>
					 <a-select-option :key="5" :value="5">冲刺班</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-select v-model="form.campus_id" mode="multiple" placeholder="校区" style="width: 150px;" allow-clear>
                    <a-select-option v-for="item in campusList" :key="item.id" :value="item.id">{{ item.name }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-select v-model="form.course_id" placeholder="课程" style="width: 220px;" allow-clear>
                    <a-select-option v-for="(item) in courseList" :key="item.id" :value="item.id">{{ item.name }}
                    </a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item>
                <a-select v-model="form.year_name" placeholder="年度" allow-clear style="width: 120px;">
                    <a-select-option :key="0" value="2020">2020年</a-select-option>
                    <a-select-option :key="1" value="2021">2021年</a-select-option>
                    <a-select-option :key="2" value="2022">2022年</a-select-option>
                    <a-select-option :key="3" value="2023">2023年</a-select-option>
					<a-select-option :key="4" value="2024">2024年</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-select v-model="form.grade_id" mode="multiple" placeholder="年级" style="width: 220px;" allow-clear>
                    <a-select-option v-for="(item) in nianjiList" :key="item.id" :value="item.id">{{ item.name }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-select v-model="form.semester_name" placeholder="季度" allow-clear style="width: 120px;">
                    <a-select-option :key="0" value="寒假">寒假</a-select-option>
                    <a-select-option :key="1" value="春季">春季</a-select-option>
                    <a-select-option :key="2" value="暑假">暑假</a-select-option>
                    <a-select-option :key="3" value="秋季">秋季</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-select v-model="form.is_famission" placeholder="是否发送任务" allow-clear style="width: 80px;">
                    <a-select-option :key="0" :value="0">不发送</a-select-option>
                    <a-select-option :key="1" :value="1">发送</a-select-option>

                </a-select>
            </a-form-item>
            <a-form-item>
                <a-select v-model="form.opening" placeholder="开班状态" allow-clear style="width: 120px;">
                    <a-select-option :key="0" :value="0">未开班</a-select-option>
                    <a-select-option :key="1" :value="1">已开班</a-select-option>
                    <a-select-option :key="2" :value="2">已结班</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-select v-model="form.status" placeholder="班级状态" allow-clear style="width: 120px;">
                    <a-select-option :key="0" :value="0">禁用</a-select-option>
                    <a-select-option :key="1" :value="1">可用</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-input placeholder="班级名称" v-model="form.keyword" @keyup.enter="tableSearch"></a-input>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" htmlType="submit" @click="exportData">导出</a-button>
            </a-form-item>
        </a-form>
		  <h3> 总计：{{ counts }}</h3>
        <a-table :dataSource="data" :loading="loading" :rowKey="item => item.id" @change="onPaginationChange" bordered
            :pagination="pageinfo">
            <a-table-column key="name" data-index="name" title="姓名" />
            <a-table-column key="nickname" data-index="nickname" title="昵称" />
            <a-table-column key="mobile" data-index="mobile" title="电话" />
            <a-table-column key="campusname" data-index="campusname" title="校区" />
            <a-table-column key="grade_name" data-index="grade_name" title="年级" />
            <a-table-column key="squadname" data-index="squadname" title="班级" />
            <a-table-column key="subject" data-index="subject" title="科目" />
            <a-table-column key="banzhuren" data-index="banzhuren" title="班主任" />
            <a-table-column key="teachername" data-index="teachername" title="教学老师" />
            <a-table-column key="jion_time" title="入学时间">
                <template slot-scope="item">
                    {{ new Date(item.jion_time * 1000).toLocaleString() }}
                </template>
            </a-table-column>
        </a-table>
    </or-layout>
</template>

<script>
export default {
    data() {
        return {
            gradeList: [],
            subjectList: [
                { id: 1, name: '数学' },
                { id: 2, name: '英语' },
                { id: 3, name: '语文' }
            ],
            nianjiList: [],
            campusList: [],
            courseList: [],
			counts: undefined,
            form: {
                keyword: undefined,
                course_id: undefined,
                campus_id: undefined,
                subject: undefined,
                opening: 1,
                status: 1,
                is_export: 0
            },
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 10
            },
            loading: false,
            data: []
        }
    },
    created() {
        this.getCampusList();
        this.getGradeList();
        this.getNianjiList();
        // this.getData();
    },
    methods: {
        getGradeList() {
            this.$axios.post("/api/BasicGrade/index").then(res => {
                if (res.code != 200) {
                    this.$error({
                        title: "错误",
                        content: res.msg,
                        okText: "确定"
                    });
                } else {
                    this.gradeList = res.data.data;
                }
            }).catch(err => {
                console.error(err);
            });
        },
        getCourseList() {
            this.$axios
                .post("/api/BasicCourse/index", { pageinfo: { pageSize: 9999 } })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.courseList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getCampusList() {
            this.$axios
                .post("/api/Admin/getorgsquadlist")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.campusList = res.data.org_campus;
                        this.tableSearch();
                        this.getCourseList();
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        tableSearch() {
            this.pageinfo.current = 1;
            this.getData(this.form);
        },
        getNianjiList() {
            this.$axios
                .post("/api/BasicGrade/index", {
                    pageinfo: {
                        pageSize: 999
                    }
                })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.nianjiList = res.data.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        getData(form) {
            this.loading = true;
            this.$axios.post('/api/student/getStudentListbysquad', {
                data:form,
                pageinfo: this.pageinfo
            }).then(res => {
                this.loading = false;
                if (res.code == 200) {
                    if (this.form.is_export === 1) {
                        this.form.is_export = 0;
                        window.open(res.data)
                    } else if (this.form.is_export === 0) {
                        this.data = res.data.data;
						 this.counts = res.data.counts;
                        this.pageinfo = res.data.pageinfo;
                    }
                }
            }).catch(error => {
                this.loading = false;
            })
        },
        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getData(this.form)
        },
        exportData() {
            this.form.is_export = 1;
            this.getData(this.form)
        }
    }
}
</script>

<style lang="less" scoped></style>